{
  "bookingWidgetTabs": {
    "carTrawler": {
      "title": "Rent a car and collect Avios",
      "poweredBy": "Powered by",
      "pickupLocation": "Pick-up location",
      "pickupAndDropoff": "Pick-up and return location",
      "dropoffLocation": "Return location",
      "locationPlaceholder": "City or airport",
      "differentDropoff": "Return to a different location",
      "pickupDate": "Pick-up date",
      "dropoffDate": "Return date",
      "time": "Time",
      "selectTimePlaceholder": "Select time",
      "pickupTime": "Pick-up time",
      "dropoffTime": "Return time",
      "driverAge": "Driver's age",
      "driverAgeSelection": {
        "label": "Driver's age",
        "other": "Other"
      },
      "ctaButton": "Find a car"
    },
    "hotels": {
      "title": "Book a hotel and collect Avios",
      "poweredBy": "Powered by",
      "destination": "Where to?",
      "destinationPlaceholder": "Add destination",
      "checkInDate": "Start date",
      "checkOutDate": "End date",
      "guestsAndRooms": "Guests and rooms",
      "room": "Room",
      "remove": "Remove",
      "addRoom": "Add room",
      "ctaButton": "Find a hotel",
      "guests": {
        "adult": "Adult",
        "child": "Child 0 – 17",
        "totalRooms": {
          "singular": "{0} room",
          "plural": "{0} rooms"
        },
        "totalAdults": {
          "singular": "{0} adult",
          "plural": "{0} adults"
        },
        "totalChildren": {
          "singular": "{0} child",
          "plural": "{0} children"
        },
        "ageUponCheckIn": "Age upon check-in",
        "ageOfChild": "Age of child",
        "ageSelect": "Select",
        "addAdult": "Add adult",
        "removeAdult": "Remove adult",
        "addChild": "Add child",
        "removeChild": "Remove child",
        "year": "year",
        "years": "years",
        "childAge": {
          "required": "Please select the child's age"
        }
      },
      "aviosNotification": "Finnair Plus members also enjoy members-only prices on hotel stays."
    }
  }
}
